module.exports = __webpack_public_path__ + "static/media/b34@2x.ecdadabe.png";